import { defineDirective } from '~/scripts/utils/alpine'

/**
 * x-reveal directive
 * @example adds the class 'revealed' to an element when it's 20% above the fold
 * <div x-reveal></div>
 */
export default defineDirective((element, _directive, { cleanup }) => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed')
        observer.unobserve(entry.target)
      }
    },
    { threshold: 0 },
  )

  observer.observe(element)

  cleanup(() => {
    observer.unobserve(element)
  })
})
